import FileUpload from './src/main.js';
export default FileUpload;
